export default __webpack_public_path__ + "static/media/news5.b990abdb.mp4";